export type {
    PostProcessor,
    PostProcessorsRootMap,
} from './types';
export { createPostProcessor } from './createPostProcessor';
